class BackToTop {
  constructor() {
    this.backtotop = document.querySelector('.wp-backtotop');
    this.footer = document.querySelector('.wp-footer');
    this.prevnext = document.querySelector('.wp-prev-next__container');

    if(this.backtotop){
      this.bindBackToTop();
      this.bindScrolling();
    }
  }

  bindBackToTop(){
    this.backtotop.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  bindScrolling() {
    window.onscroll = () => {

      let add = 0;

      if (window.innerWidth > 768) {
        add = 42;

        if(this.prevnext){
          add = -44;
        }
      }
      else {
        add = 57;

        if(this.prevnext){
          add = 24;
        }
      }

      let offsetVar =
        window.scrollY +
        this.backtotop.offsetHeight +
        window.innerHeight - add;

      let offsetAn =  this.footer.offsetTop;

      let offsetTarget = offsetAn - offsetVar;

      if(offsetTarget <= 0) {
        this.backtotop.style.marginTop = offsetTarget + "px";
      } else {
        this.backtotop.style.marginTop = "0px";
      }
    }
  }
}
export default BackToTop;












